var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClasses},[_c('b-form-select',{attrs:{"options":_vm.selectItems,"value-field":_vm.valueField,"text-field":_vm.textField},on:{"change":_vm.enableFilter},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }